import { Injectable } from '@angular/core';
import { FollowStateEnum } from '@shared/model/enum/follow-state-enum';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FollowResultHandlerService {

  private followComponentRef: any;
  private methodSubject = new Subject<any>();

  setComponentRef(ref: any): void {
    this.followComponentRef = ref;
  }

  callNewStateHandler(methodName: string, result: FollowStateEnum): void {
    if (this.followComponentRef && typeof this.followComponentRef[methodName] === 'function') {
      this.followComponentRef[methodName](result);
    }
  }

  getFollowResponse$() {
    return this.methodSubject.asObservable();
  }

  emitMethodCall(methodName: string, ...args: any[]): void {
    this.methodSubject.next({ methodName, args });
  }
}
